export type TokenizationError = {
  invalidFields?: string[];
  errors?: string | string[];
  status?: number;
};

export interface PaymentsSDK {
  load: (config: Record<string, any>, handlers?: Record<string, any>) => {};
  unload: () => void;
  token: (
    element: HTMLElement,
    successHandler: (token: string) => void,
    errorHandler: (error: TokenizationError) => void
  ) => {};
}

export interface PaymentsSDKConstructable {
  new (): PaymentsSDK;
}

export type PaymentsFormConfig = {
  securityToken: string | null;
  publicKey: string | null;
  serverHost: string | null;
};

export type CreditCardFields = {
  firstName: string;
  lastName: string;
};

export enum CreditCardPCIFields {
  Number = 'number',
  SecurityCode = 'cvv',
  ExpirationMonth = 'month',
  ExpirationYear = 'year',
}

export type DetectedCardType =
  | 'american-express'
  | 'default'
  | 'diners'
  | 'diners-club'
  | 'discover'
  | 'jcb'
  | 'maestro'
  | 'mastercard'
  | 'visa';
